import React, { useEffect, useState, PropsWithChildren } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';

import { Loader } from 'components/Loader/Loader';
import { usePatient } from 'hooks/usePatient/usePatient';
import { checkAndSetConsent } from 'utilities/consent';
import { pageUrl } from 'utilities/pageUrl';
import { getPostLogoutLandingUrl } from 'utilities/userUtil';

import { useTestPatientAuth } from './ProtectedRoute.hook';

export const ProtectedRoute = ({ children }: PropsWithChildren<unknown>) => {
  const [redirected, setRedirected] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn } = usePatient();
  useTestPatientAuth(Boolean(isLoggedIn));

  useEffect(() => {
    const consent = checkAndSetConsent();
    if (consent) {
      if (redirected || location.pathname.includes(`${pageUrl.consents()}/`)) return;

      setRedirected(true);
      navigate(pageUrl.consents(consent), { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoggedIn == null) return <Loader absoluteCentered />;

  if (!isLoggedIn) {
    const returnUrl =
      location.pathname === '/' ? null : encodeURIComponent(location.pathname + location.search);

    if (
      (location.pathname === pageUrl.booking.book() && location.search.includes('membership_id')) ||
      location.search.includes('enterprise_membership')
    ) {
      if (returnUrl) {
        return (
          <Navigate to={pageUrl.createAccount({ step: 'create_account', target: returnUrl })} />
        );
      }
      return <Navigate to={pageUrl.createAccount()} />;
    }

    const postLogoutLandingUrl = getPostLogoutLandingUrl();

    if (postLogoutLandingUrl) {
      window.location.href = postLogoutLandingUrl;
      return null;
    }
    if (returnUrl) {
      return <Navigate to={pageUrl.login({ target: returnUrl })} />;
    } else {
      return <Navigate to={pageUrl.login()} />;
    }
  }

  return (children as React.JSX.Element) ?? null;
};
